import { render } from "./ClinicViewHeader.vue?vue&type=template&id=e209e3f2&ts=true"
import script from "./ClinicViewHeader.vue?vue&type=script&lang=ts"
export * from "./ClinicViewHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__